import { render, staticRenderFns } from "./SettingsTravelServiceMailSubjectView.vue?vue&type=template&id=5c64e47d&scoped=true&"
import script from "./SettingsTravelServiceMailSubjectView.vue?vue&type=script&lang=js&"
export * from "./SettingsTravelServiceMailSubjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64e47d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c64e47d')) {
      api.createRecord('5c64e47d', component.options)
    } else {
      api.reload('5c64e47d', component.options)
    }
    module.hot.accept("./SettingsTravelServiceMailSubjectView.vue?vue&type=template&id=5c64e47d&scoped=true&", function () {
      api.rerender('5c64e47d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/travel-service/SettingsTravelServiceMailSubjectView.vue"
export default component.exports